<template>
  <div id="vue-gallery" style="background-color: transparent">
    <LightBox 
      ref="lightbox"
      :show-caption="true"
      :show-light-box="isShow"
    ></LightBox>
  </div>
</template>

<script>

import LightBox from './components/LightBox.vue'

export default {
  name: 'app-gallery',
  components: {
    LightBox
  },
  computed: {
    isShow() {
      return this.$store.getters['gallery/isShow'];
    },
  },
}
</script>